import styles from "./protocolsMenuPage.module.css";
import { Link, useNavigate } from "react-router-dom";
import useMediaQuery from "../../hooks/useMediaQuery";
import { mobileWidth } from "../../utils/constants";
import { protocolCategories } from "../../utils/categories";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { useGetHotlineScopeQuery } from "../../services/api/hotlineQuestionnaire.api";


function ProtocolsMenuPage() {
  const navigate = useNavigate();
  const mobile = useMediaQuery(mobileWidth);

  // The returning-caller rule is off for most tenants, and a tab leading to a screen that cannot
  // do anything is worse than no tab. It appears once the company switches the rule on under
  // company settings.
  const { data: hotlineScope } = useGetHotlineScopeQuery();

  const categories = protocolCategories.filter(
    (cat) => cat.value !== "hotline" || hotlineScope?.enabled === true
  );

  return (
    <section className={`menuSection`} data-testid="protocols-section">
      <ul className={`options`}>
        {categories.map((cat) => (
          <Link
            to={`/protocols/${cat.value}`}
            key={cat.value}
            className={`option hover`}
          >
            {t(cat.label)}
          </Link>
        ))}
        
        {/* {mobile && (
          <button
            onClick={() => navigate(-1)}
            className={`button ${styles.btn} hover`}
          >{t('PREVIOUS_SCREEN')}</button>
        )} */}
      </ul>
    </section>
  );
}

export default ProtocolsMenuPage;
